// One Country Global Scripts

// Deprecated HTML Tag Sanitization Utility (WCAG 1.3.1)
// Replaces deprecated presentational tags with semantic equivalents
const sanitizeDeprecatedTags = (element) => {
  // Replace <center> with div with text-align
  element.querySelectorAll('center').forEach(center => {
    const div = document.createElement('div');
    div.style.textAlign = 'center';
    div.innerHTML = center.innerHTML;
    center.replaceWith(div);
  });
  
  // Replace <font> with span (fonts should be set via CSS)
  element.querySelectorAll('font').forEach(font => {
    const span = document.createElement('span');
    span.innerHTML = font.innerHTML;
    font.replaceWith(span);
  });
  
  // Replace <u> with <ins> (semantic equivalent for underline)
  element.querySelectorAll('u').forEach(u => {
    const ins = document.createElement('ins');
    ins.innerHTML = u.innerHTML;
    u.replaceWith(ins);
  });
  
  // Replace <b> (when not semantic) with <strong> for consistency
  element.querySelectorAll('b').forEach(b => {
    if (!b.closest('strong')) {
      const strong = document.createElement('strong');
      strong.innerHTML = b.innerHTML;
      b.replaceWith(strong);
    }
  });
  
  // Replace <i> (when not semantic) with <em> for consistency  
  element.querySelectorAll('i').forEach(i => {
    if (!i.closest('em') && !i.classList.length) { // Skip icon <i> tags with classes
      const em = document.createElement('em');
      em.innerHTML = i.innerHTML;
      i.replaceWith(em);
    }
  });
};

// Auto-sanitize elements with data-sanitize-deprecated attribute
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-sanitize-deprecated]').forEach(el => {
    sanitizeDeprecatedTags(el);
  });
});

// Watch for dynamically added content with deprecated tags
// const observer = new MutationObserver((mutations) => {
//   mutations.forEach((mutation) => {
//     if (mutation.type === 'childList') {
//       mutation.addedNodes.forEach((node) => {
//         if (node.nodeType === 1 && node.hasAttribute && node.hasAttribute('data-sanitize-deprecated')) {
//           sanitizeDeprecatedTags(node);
//         }
//       });
//     }
//   });
// });

// observer.observe(document.body, {
//   childList: true,
//   subtree: true
// });

// Aria-Hidden Focus Management (WCAG 4.1.2 Name, Role, Value)
// Ensures elements with aria-hidden="true" have their focusable children removed from tab order
// Re-enables tab order when aria-hidden is set to false
const manageAriaHiddenFocus = () => {
  const focusableSelector = 'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])';
  
  document.querySelectorAll('[aria-hidden="true"]').forEach(hiddenContainer => {
    const focusableElements = hiddenContainer.querySelectorAll(focusableSelector);
    focusableElements.forEach(element => {
      // Store original tabindex if not already stored
      if (!element.hasAttribute('data-original-tabindex')) {
        const originalTabindex = element.getAttribute('tabindex');
        element.setAttribute('data-original-tabindex', originalTabindex || '0');
      }
      // Set tabindex to -1 to remove from focus order
      element.setAttribute('tabindex', '-1');
    });
  });
};

// Re-enable tab order for elements that were just revealed
const restoreAriaRevealedFocus = () => {
  document.querySelectorAll('[aria-hidden="false"], [aria-hidden=""]').forEach(revealedContainer => {
    const focusableElements = revealedContainer.querySelectorAll('[data-original-tabindex]');
    focusableElements.forEach(element => {
      const originalTabindex = element.getAttribute('data-original-tabindex');
      if (originalTabindex === '0') {
        element.removeAttribute('tabindex');
      } else {
        element.setAttribute('tabindex', originalTabindex);
      }
    });
  });
};

// Run on initial load
document.addEventListener('DOMContentLoaded', () => {
  manageAriaHiddenFocus();
});

// Watch for aria-hidden changes
const ariaHiddenObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
      const target = mutation.target;
      if (target.getAttribute('aria-hidden') === 'true') {
        // Element is being hidden
        const focusableElements = target.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
        focusableElements.forEach(element => {
          if (!element.hasAttribute('data-original-tabindex')) {
            const originalTabindex = element.getAttribute('tabindex');
            element.setAttribute('data-original-tabindex', originalTabindex || '0');
          }
          element.setAttribute('tabindex', '-1');
        });
      } else {
        // Element is being revealed (aria-hidden="false" or removed)
        restoreAriaRevealedFocus();
      }
    }
  });
});

ariaHiddenObserver.observe(document.body, {
  attributes: true,
  attributeFilter: ['aria-hidden'],
  subtree: true
});

// Ensure cartItemData is globally defined
let cartItemData = {};
let productCompareAtCache = {};

function getProductHandleFromUrl(url) {
  if (!url) return null;
  const match = url.match(/\/products\/([^/?#]+)/);
  return match ? match[1] : null;
}

function getCompareAtLinePriceFromItem(item) {
  const handle = item.handle || getProductHandleFromUrl(item.url);
  if (!handle || !item.variant_id) return Promise.resolve('');

  if (productCompareAtCache[handle]) {
    const matchedVariant = productCompareAtCache[handle].variants?.find(variant => String(variant.id) === String(item.variant_id));
    if (matchedVariant && Number(matchedVariant.compare_at_price || 0) > Number(item.price || 0)) {
      return Promise.resolve((Number(matchedVariant.compare_at_price || 0) * Number(item.quantity || 1) / 100).toFixed(2));
    }
    return Promise.resolve('');
  }

  return fetch(`/products/${handle}.js`)
    .then(response => {
      if (!response.ok) throw new Error('Failed to fetch product JSON');
      return response.json();
    })
    .then(productData => {
      productCompareAtCache[handle] = productData;
      const matchedVariant = productData.variants?.find(variant => String(variant.id) === String(item.variant_id));
      if (matchedVariant && Number(matchedVariant.compare_at_price || 0) > Number(item.price || 0)) {
        return (Number(matchedVariant.compare_at_price || 0) * Number(item.quantity || 1) / 100).toFixed(2);
      }
      return '';
    })
    .catch(() => '');
}


// Initialize the global gift item count
window.giftItemCount = 0;
  
// Global listener for all focus changes on the page
document.addEventListener('focusin', (event) => {
  console.log('Focused element:', event.target);
});

class DropdownManager {
  constructor() {
    // Target any megadropdown anchors within the desktop navigation.
    this.navItems = document.querySelectorAll('.site-nav .first-list-item.megadropdown > a');
    this.activeDropdown = null; // Track the currently active dropdown.
    this.init();
  }

  init() {
    this.navItems.forEach((navItem) => {
      const dropdown = navItem.nextElementSibling;

      // WCAG 2.1.1: Set initial ARIA state so screen readers know a submenu exists.
      if (dropdown) {
        navItem.setAttribute('aria-haspopup', 'true');
        navItem.setAttribute('aria-expanded', 'false');
        dropdown.setAttribute('aria-hidden', 'true');
      }

      // Show dropdown on hover (mouse users). For keyboard users, Enter/Space/ArrowDown
      // opens the dropdown and moves focus into it (see keydown handler below).
      navItem.addEventListener('mouseenter', () => this.showDropdown(dropdown, navItem));

      // Also, if the mouse enters the dropdown container, ensure it stays open.
      if (dropdown) {
        dropdown.addEventListener('mouseenter', () => this.showDropdown(dropdown, navItem));
        dropdown.addEventListener('focusin', () => this.showDropdown(dropdown, navItem));
      }

      // Hide dropdown on blur or when focus leaves the nav item or its dropdown.
      navItem.addEventListener('blur', (e) => this.hideDropdownOnBlurOrMouseLeave(e, dropdown, navItem));
      if (dropdown) {
        dropdown.addEventListener('focusout', (e) => this.hideDropdownOnBlurOrMouseLeave(e, dropdown, navItem));
      }

      // On mouseleave, wait briefly and hide if neither element is hovered.
      navItem.addEventListener('mouseleave', () => {
        setTimeout(() => {
          if (!navItem.matches(':hover') && !(dropdown && dropdown.matches(':hover'))) {
            this.hideDropdown(dropdown, navItem);
          }
        }, 100);
      });
      if (dropdown) {
        dropdown.addEventListener('mouseleave', () => {
          setTimeout(() => {
            if (!navItem.matches(':hover') && !dropdown.matches(':hover')) {
              this.hideDropdown(dropdown, navItem);
            }
          }, 100);
        });
      }

      // ---- Keydown handler for Enter/Space/ArrowDown on desktop nav items.
      // If the link has an associated dropdown, prevent its default click action
      // and toggle the dropdown instead. On open, move focus into the first link
      // so keyboard users can Tab through submenu items. (WCAG 2.1.1)
      navItem.addEventListener('keydown', (e) => {
        if ((e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') && dropdown) {
          e.preventDefault();
          if (dropdown.classList.contains('active')) {
            this.hideDropdown(dropdown, navItem);
          } else {
            this.showDropdown(dropdown, navItem);
            // Move focus to first focusable link inside the dropdown.
            const firstLink = dropdown.querySelector('a, button');
            if (firstLink) firstLink.focus();
          }
        }
      });

      navItem.addEventListener('keydown', (e) => {
        if (e.key === ' ' && !dropdown) {
          e.preventDefault();
          navItem.click();
        }
      });
    });

    // Listen for the Escape key globally to hide any active dropdown.
    document.addEventListener('keydown', (e) => this.handleGlobalKeydown(e));
  }

  showDropdown(dropdown, navItem) {
    this.activeDropdown = { dropdown, navItem }; // Track the active dropdown.
    if (dropdown) {
      dropdown.classList.add('active');
      dropdown.setAttribute('aria-hidden', 'false');
      this.setDropdownTabbing(dropdown, true);
    }
    navItem.setAttribute('aria-expanded', 'true');
  }

  hideDropdown(dropdown, navItem) {
    this.activeDropdown = null; // Clear the active dropdown.
    if (dropdown) {
      dropdown.classList.remove('active');
      dropdown.setAttribute('aria-hidden', 'true');
      this.setDropdownTabbing(dropdown, false);
    }
    navItem.setAttribute('aria-expanded', 'false');
  }

  setDropdownTabbing(dropdown, enabled) {
    if (!dropdown) return;

    dropdown.querySelectorAll('a, button').forEach((element) => {
      if (!element.hasAttribute('data-dropdown-original-tabindex')) {
        const managedOriginalTabindex = element.getAttribute('data-original-tabindex');
        const currentTabindex = element.getAttribute('tabindex');
        let originalTabindex = currentTabindex;

        if (managedOriginalTabindex !== null) {
          originalTabindex = managedOriginalTabindex === '0' ? '' : managedOriginalTabindex;
        } else if (currentTabindex === '-1') {
          originalTabindex = '';
        }

        element.setAttribute('data-dropdown-original-tabindex', originalTabindex === null ? '' : originalTabindex);
      }

      if (enabled) {
        const originalTabindex = element.getAttribute('data-dropdown-original-tabindex');
        if (originalTabindex === '') {
          element.removeAttribute('tabindex');
        } else {
          element.setAttribute('tabindex', originalTabindex);
        }
      } else {
        element.setAttribute('tabindex', '-1');
      }
    });
  }

  handleGlobalKeydown(e) {
    if (e.key === 'Escape' && this.activeDropdown) {
      const { dropdown, navItem } = this.activeDropdown;
      this.hideDropdown(dropdown, navItem);
      navItem.focus(); // Return focus to the nav item.
    }
  }

  hideDropdownOnBlurOrMouseLeave(e, dropdown, navItem) {
    setTimeout(() => {
      // Only hide if neither the nav item nor the dropdown contains the focused element.
      if (
        !navItem.contains(document.activeElement) &&
        !(dropdown && dropdown.contains(document.activeElement))
      ) {
        this.hideDropdown(dropdown, navItem);
      }
    }, 10);
  }
}

// Initialize DropdownManager after DOM content is loaded.
document.addEventListener('DOMContentLoaded', () => {
  new DropdownManager();
});


class CookieManager {
  static setCookie(name, value, days) {
    let expires = "";
    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  static getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  static updateUserData(name, gender, size, days) {
    let cookieValue = this.getCookie(name);
    let cookieData = cookieValue ? JSON.parse(cookieValue) : { gender: gender, genderHistory: '', sizeHistory: '' };

    // Update genderHistory
    if (!cookieData['genderHistory']) {
      cookieData['genderHistory'] = [];
    } else {
      cookieData['genderHistory'] = cookieData['genderHistory'].split(',');
    }
    cookieData['genderHistory'].push(gender);
    if (cookieData['genderHistory'].length > 20) {
      cookieData['genderHistory'].shift();
    }

    // Update sizeHistory
    if (!cookieData['sizeHistory']) {
      cookieData['sizeHistory'] = [];
    } else {
      cookieData['sizeHistory'] = cookieData['sizeHistory'].split(',');
    }
    cookieData['sizeHistory'].push(size);
    if (cookieData['sizeHistory'].length > 20) {
      cookieData['sizeHistory'].shift();
    }

    // Calculate majority gender and size
    cookieData['gender'] = this.calculateMajority(cookieData['genderHistory']);
    cookieData['size'] = this.calculateMajority(cookieData['sizeHistory'], true);

    // Convert history arrays back to strings
    cookieData['genderHistory'] = cookieData['genderHistory'].join(',');
    cookieData['sizeHistory'] = cookieData['sizeHistory'].join(',');

    // Update the cookie with the final values
    this.setCookie(name, JSON.stringify(cookieData), days);
  }

  // Calculate the majority in history arrays
  static calculateMajority(historyArray, isSize = false) {
    if (historyArray.length <= 3) return null; // Not enough entries to calculate majority

    let count = historyArray.reduce((acc, item) => {
      acc[item] = (acc[item] || 0) + 1;
      return acc;
    }, {});

    let twoThirds = Math.ceil((2 / 3) * historyArray.length);
    let majorityItem = null;

    for (let item in count) {
      if (count[item] >= twoThirds) {
        majorityItem = item;
        break;
      }
    }

    return majorityItem;
  }
}



// Get shipping limit from theme settings
let shippingLimit = document.querySelector('.ocs-minicart').getAttribute('data-shipping-limit');
shippingLimit = parseFloat(shippingLimit).toFixed(2);

// Debounce function
function debounce(fn, delay) {
  let timeoutId;
  return function(...args) {
    clearTimeout(timeoutId);
    return new Promise((resolve, reject) => {
      timeoutId = setTimeout(() => {
        Promise.resolve(fn.apply(this, args)).then(resolve).catch(reject);
      }, delay);
    });
  };
}

// Update header cart count function
function updateHeaderCartCount(itemCount) {
  document.querySelectorAll('.cart .count').forEach(headerCartCount => {
    if (!headerCartCount) return;

    headerCartCount.textContent = itemCount === 0 ? '' : itemCount;

    if (itemCount <= 0) {
      headerCartCount.classList.add('empty');
      headerCartCount.classList.remove('active');
    } else {
      headerCartCount.classList.remove('empty');
      headerCartCount.classList.add('active');
    }
  });

  // WCAG 4.1.3: Keep cart button aria-label in sync with item count (#1)
  const cartBtn = document.querySelector('.toggle-minicart');
  if (cartBtn) {
    const label = 'Open cart, ' + itemCount + ' ' + (itemCount === 1 ? 'item' : 'items');
    cartBtn.setAttribute('aria-label', label);
  }
}

// Function to count gift items in the cart (items priced $0)
function countGiftItems(cart) {
  window.giftItemCount = cart.items.reduce((count, item) => {
    if (parseFloat(item.price / 100) === 0) {
      count += item.quantity; // Count each quantity of gift items
    }
    return count;
  }, 0);

  console.log(`Number of gift items in cart: ${window.giftItemCount}`);
}

// Function to check if cart total is zero but has items, then clear the cart
async function checkAndClearCartIfTotalIsZero() {
  try {
    // Fetch the cart data
    const cart = await fetch('/cart.js').then(response => response.json());

    // Check if the cart total is 0 and there are items in the cart
    if (cart.total_price === 0 && cart.items.length > 0) {
      console.log('Cart total is $0, but there are items in the cart. Clearing cart now...');
      await clearCart();
    } else {
      console.log('Cart does not meet the criteria for clearing.');
    }

  } catch (error) {
    console.error('Error checking cart total:', error);
  }
}

// Usage example:
// This function can be called after cart updates or page load to ensure consistency.
document.addEventListener('DOMContentLoaded', () => {
  checkAndClearCartIfTotalIsZero();
});


// Global function to fetch cart data and update the mini-cart
function fetchCartData() {
  checkAndClearCartIfTotalIsZero();
  return fetch('/cart.js')
    .then(response => response.json())
    .then(async cart => {
      //console.log('Cart:', cart);
      let cartBody = document.querySelector('.cart-body');
      let cartFooter = document.querySelector('.cart-footer');
      let cartSummary = document.querySelector('.cart-summary');
      let shippingHeaderMessage = document.querySelector('.shipping-header-message');
      let emptyCartContent = document.querySelector('.empty-cart-content');
      let headerCartCount = document.querySelector(".header-cart-count");
      let shippingBarProgress = document.querySelector('.shipping-bar-progress');
      let shippingBar = document.querySelector('.bar');
      let cartDiscountLine = document.querySelector('.discount-ammount');

      // Fetch the dp_user cookie and parse it to get the gender value
      let dpUserCookie = CookieManager.getCookie('dp_user');
      let genderSetting = dpUserCookie ? JSON.parse(dpUserCookie).gender : null;
      //console.log('Gender Setting: ', genderSetting);

      if(genderSetting == 'M') {
        document.querySelectorAll('.mens-upsell-collection').forEach(x => {x.style.display = "flex"});
        document.querySelectorAll('.womens-upsell-collection').forEach(x => {x.style.display = "none"});
        document.querySelectorAll('.unisex-upsell-collection').forEach(x => {x.style.display = "none"});

      } else if (genderSetting == 'W') {
        document.querySelectorAll('.mens-upsell-collection').forEach(x => {x.style.display = "none"});
        document.querySelectorAll('.womens-upsell-collection').forEach(x => {x.style.display = "flex"});
        document.querySelectorAll('.unisex-upsell-collection').forEach(x => {x.style.display = "none"});

      } else {
        document.querySelectorAll('.mens-upsell-collection').forEach(x => {x.style.display = "none"});
        document.querySelectorAll('.womens-upsell-collection').forEach(x => {x.style.display = "none"});
        document.querySelectorAll('.unisex-upsell-collection').forEach(x => {x.style.display = "flex"});

      }

      // Check if the cart is empty
      if (cart.items.length === 0) {
        //console.log('Cart is empty.');
        cartBody.classList.add('empty');
        if (emptyCartContent) emptyCartContent.style.display = "block";
        if (cartFooter) cartFooter.style.display = 'none';
        if (cartSummary) cartSummary.style.display = 'none';
        if (headerCartCount) headerCartCount.innerHTML = '(0 Items)';
        if (shippingHeaderMessage) {
          shippingHeaderMessage.textContent = `FREE SHIPPING ON ORDERS $${shippingLimit} OR MORE.`;
          shippingHeaderMessage.style.display = "none";
        }
        if (shippingBarProgress) {
          shippingBarProgress.style.width = '0%';
          shippingBar.style.display = "none";
        }
        
        updateHeaderCartCount(0);
        return;
      } else {
        cartBody.classList.remove('empty');
        if (cartSummary) cartSummary.style.display = 'block';
        if (emptyCartContent) emptyCartContent.style.display = "none";
        if (shippingBar) shippingBar.style.display = "block";
        if (shippingHeaderMessage) shippingHeaderMessage.style.display = "block";
        if (cartFooter) cartFooter.style.display = 'block';
      }

      const compareAtLinePrices = await Promise.all(cart.items.map(item => getCompareAtLinePriceFromItem(item)));

      // Update the stored cart item data with new data from the cart
      cart.items.forEach((item, index) => {
        let variantId = item.variant_id;
        cartItemData[variantId] = {
          num: index, // Assigning the index directly from the loop
          id: `CartItem-${index + 1}`, // Using index + 1 for unique IDs if needed
          shortname: item.product_title,
          price: item.price,
          inv: item.inventory_quantity,
          featured_image: item.featured_image,
          url: item.url,
          title: item.product_title,
          options: item.options_with_values.map(option => ({
            name: option.name,
            value: option.value
          })),
          discounts: item.discounts.map(discount => discount.title),
          quantity: item.quantity,
          originalLinePrice: (item.original_line_price / 100).toFixed(2),
          compareAtLinePrice: compareAtLinePrices[index]
        };
        //console.log('item ');
        //console.log(item.product);
      });

      let newTotalDiscount = (cart.total_discount / 100).toFixed(2);
      if(cartDiscountLine){
        cartDiscountLine.textContent = '-$' + newTotalDiscount;
      }
      
      let newCartTotal = (cart.total_price / 100).toFixed(2);
      document.querySelector('.cart-total-value').textContent = '$' + newCartTotal;
      headerCartCount.innerHTML = `(${cart.item_count} Item${cart.item_count > 1 ? 's' : ''})`;

      if (emptyCartContent) emptyCartContent.style.display = 'none';
      if (cartSummary) cartSummary.style.display = 'block';

      // Update shipping progress if necessary
      updateShipping(newCartTotal, shippingLimit);
      updateHeaderCartCount(cart.item_count); // Update header cart count

      // Recreate the HTML for <cart-items>
      renderCartItems();

      // Count and display the number of gift items
      countGiftItems(cart);

      return cart;
    })
    .catch(error => console.error('Error fetching cart:', error));
}

// Function to update shipping progress
function updateShipping(cartTotal, shippingLimit) {
  shippingLimit = parseFloat(shippingLimit).toFixed(2); // Ensure it's a number with two decimal places
  let freeShippingPercent = ((cartTotal / shippingLimit) * 100).toFixed(0);
  let progressBar = document.querySelector(".shipping-bar-progress");
  let shippingSummaryText = document.querySelector(".shipping-type");
  let shippingHeader = document.querySelector(".shipping-header-message");
  if (freeShippingPercent >= 100) {
    freeShippingPercent = 100;
  }
  progressBar.style.width = freeShippingPercent + "%";
  if (freeShippingPercent >= 100) {
    shippingSummaryText.innerHTML = "<span>Free Shipping!</span>";
    shippingHeader.innerHTML = "YOU'VE EARNED FREE SHIPPING!";
  } else {
    shippingSummaryText.textContent = "Calculated in Checkout";
    if (freeShippingPercent == 0) {
      shippingHeader.innerHTML = "FREE SHIPPING ON ORDERS $" + shippingLimit + " OR MORE.";
    } else {
      let neededAmount = (shippingLimit - cartTotal).toFixed(2);
      shippingHeader.innerHTML = "ADD $" + neededAmount + " OR MORE TO GET FREE SHIPPING!";
    }
  }
}
// WCAG 4.1.3: Announce cart status changes to screen readers via live region (#2, #3)
function announceCartStatus(message) {
  var liveRegion = document.getElementById('cart-live-region');
  if (liveRegion) {
    liveRegion.textContent = '';
    setTimeout(function() { liveRegion.textContent = message; }, 50);
  }
}

// Function to capture existing cart items and store their data
function captureCartItems() {
  document.querySelectorAll('.cart-item').forEach(cartItem => {
    let variantId = cartItem.getAttribute('data-id');
    let imageElement = cartItem.querySelector('.item-image img');
    let imageSrc = imageElement ? imageElement.src : '';
    let imageAlt = imageElement ? imageElement.alt : '';
    let imageAspectRatio = imageElement ? (imageElement.naturalWidth / imageElement.naturalHeight) : 1;
    let itemNameElement = cartItem.querySelector('.item-name');
    let itemName = itemNameElement ? itemNameElement.textContent.trim() : '';

    const itemPriceElement = cartItem.querySelector('.item-price');
    const salePriceElement = cartItem.querySelector('.item-price .price-item--sale');
    const comparePriceElement = cartItem.querySelector('.item-price .price-item--original');
    const endPriceElement = cartItem.querySelector('.price--end');
    let originalLinePrice = '';
    let compareAtLinePrice = '';

    if (salePriceElement) {
      originalLinePrice = salePriceElement.textContent.replace(/[^0-9.]/g, '');
    } else if (itemPriceElement) {
      originalLinePrice = itemPriceElement.textContent.replace(/[^0-9.]/g, '');
    } else if (endPriceElement) {
      originalLinePrice = endPriceElement.textContent.replace(/[^0-9.]/g, '');
    } else {
        console.warn(`Neither item price nor end price found for cart item with variant ID ${variantId}.`);
    }

    if (comparePriceElement) {
      compareAtLinePrice = comparePriceElement.textContent.replace(/[^0-9.]/g, '');
    }

    cartItemData[variantId] = {
      num: cartItem.getAttribute('data-num'),
      id: cartItem.getAttribute('id'),
      shortname: cartItem.getAttribute('data-shortname'),
      price: cartItem.getAttribute('data-price'),
      inv: cartItem.getAttribute('data-inv'),
      image: imageSrc,
      imageAlt: imageAlt,
      imageAspectRatio: imageAspectRatio,
      url: itemNameElement ? itemNameElement.href : '',
      title: itemName,
      options: [...cartItem.querySelectorAll('.product-option')].map(option => {
        let dtElement = option.querySelector('dt');
        let ddElement = option.querySelector('dd');
        return {
          name: dtElement ? dtElement.textContent.trim() : '',
          value: ddElement ? ddElement.textContent.trim() : ''
        };
      }),
      discounts: [...cartItem.querySelectorAll('.discounts__discount')].map(discount => discount.textContent.trim()),
      quantity: cartItem.querySelector('.quantity__input').value,
      originalLinePrice: originalLinePrice, // Add the calculated price here
      compareAtLinePrice: compareAtLinePrice
    };
  });
}

let quantitySelector = ``;
let productType;

// Function to recreate the HTML for <cart-items> based on the updated object
function renderCartItems() {
  let cartItemsContainer = document.querySelector('cart-items');
  cartItemsContainer.innerHTML = '';

  let keys = Object.keys(cartItemData);

  keys.sort((a, b) => {
    let priceA = parseFloat(cartItemData[a].originalLinePrice);
    let priceB = parseFloat(cartItemData[b].originalLinePrice);
    return (priceA <= 0.01) - (priceB <= 0.01); // Push free items (price <= 0.01) to the end
  });

  for (let i = 0; i < keys.length; i++) {
    let variantId = keys[i];
    let item = cartItemData[variantId];
    let index = i + 1;  // This gives you a 1-based index

    let featuredImage = item.featured_image || {
      url: item.image,
      alt: item.imageAlt,
      aspect_ratio: item.imageAspectRatio || 1
    };

    var thisItemPrice = parseFloat(item.originalLinePrice);

    if (thisItemPrice <= 0.01) {
      quantitySelector = `<div class="lock-quantity"><strong style="display:none;">${item.quantity}</strong></div>`;
      productType = 'free-product';
      
    } else {
      // WCAG 3.3.1: qty input supports keyboard entry with commit on Enter/blur.
      quantitySelector = `
      <div class="cart-item__quantity">
        <div class="cart-item__quantity-wrapper">
          <label class="visually-hidden" for="Quantity-${index}">Quantity</label>
          <quantity-input class="quantity">
            <button class="quantity_btn btn-minus" tabindex="0" name="minus" type="button" aria-label="Decrease quantity for ${item.title}"><span class="visually-hidden">Decrease quantity for ${item.title}</span>-</button>
            <input class="quantity__input" type="number" name="updates[]" value="${item.quantity}" min="1" inputmode="numeric" aria-label="${item.quantity} item of ${item.title} in cart." id="Quantity-${index}" data-index="${index}" aria-describedby="cart-qty-instructions-${index}">
            <button class="quantity_btn btn-plus" tabindex="0" name="plus" type="button" aria-label="Increase quantity for ${item.title}"><span class="visually-hidden">Increase quantity for ${item.title}</span>+</button>
          </quantity-input>
          <span id="cart-qty-instructions-${index}" class="visually-hidden">Enter a quantity, then press Enter or leave the field to update.</span>
        </div>
      </div>`;
      productType = 'standard-product';
    }
    
    const hasSaleCompare = item.compareAtLinePrice && parseFloat(item.compareAtLinePrice) > parseFloat(item.originalLinePrice);

    let cartItemHTML = `
      <div class="cart-item ${productType}" 
        data-num="${index}" 
        id="${item.id}" 
        data-id="${variantId}"
        data-title="${item.title}"
        data-shortname="${item.shortname}" 
        data-price="${item.price}"
        data-inv="${item.inv}">
        <div class="item-image">
          <img src="${featuredImage.url}&width=200" class="cart-img" alt="" aria-hidden="true" loading="lazy" width="150" height="${Math.ceil(200 / featuredImage.aspect_ratio)}">
        </div>
        <div class="item-details">
          <div class="item-contain">
            <a href="${item.url}" class="item-name">${item.title.toLowerCase()}</a>
            <div class="item-qualities">
              <dl class="item-options">
                ${item.options.map(option => `
                <div class="product-option">
                  <dt><span class="visually-hidden">${option.name}</span><span class="sep"> / </span></dt>
                  <dd>${option.value}</dd>
                </div>`).join('')}
              </dl>
              <ul class="discounts list-unstyled" role="list">
                ${item.discounts.map(discount => `<li class="discounts__discount">${discount}</li>`).join('')}
              </ul>
            </div>
            ${quantitySelector}
          </div>
        </div>
        <div class="item-totals">
          <div class="item-price">${hasSaleCompare ? `<s class="price-item price-item--original">$${parseFloat(item.compareAtLinePrice).toFixed(2)}</s>` : ''}<span class="price-item price-item--sale">$${parseFloat(item.originalLinePrice).toFixed(2)}</span></div>
          <div class="item-price-loading" style="display:none;">
              <img width="30" height="30" class="icon-loading" loading="lazy" src="https://cdn.shopify.com/s/files/1/2559/9416/files/ico-loading.gif?v=1720224887" alt="Loading" />
          </div>
          <div class="item-error"></div>
          <div class="remove-this-item" id="Remove-${index}" data-index="${index}">
            <button
              type="button"
              class="remove-btn"
              aria-label="Remove ${item.title} from cart"
            >
              Remove
            </button>
          </div>
        </div>
      </div>`;
    cartItemsContainer.insertAdjacentHTML('beforeend', cartItemHTML);
  }
}

// Function to update the cart
const updateCart = debounce((variant_id, requestedQuantity) => {
  //console.log('Updating cart for variant_id:', variant_id, 'with quantity:', requestedQuantity);
  return fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      //console.log('Cart items:', cart.items);
      //console.log('Looking for variant_id:', variant_id);

      let lineItem = cart.items.find(item => {
        //console.log('Checking item with variant_id:', item.variant_id);
        return String(item.variant_id) === String(variant_id);
      });
      //console.log('Line item found:', lineItem);

      let lineItemKey = lineItem ? lineItem.key : undefined;
      //console.log('Line item key:', lineItemKey);

      if (!lineItemKey) {
        console.log('Item not found in cart');
        return;
      }

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: lineItemKey,
          quantity: requestedQuantity
        })
      });
    })
    .then(response => {
      if (!response || !response.ok) {
        //console.log('Network response was not ok');
        return;
      }
      return fetchCartData().then(cart => {
        //console.log('Updating header cart count after updating cart:', cart.item_count); // Log
        updateHeaderCartCount(cart.item_count);

        // Check the updated quantity in the cart
        let updatedLineItem = cart.items.find(item => String(item.variant_id) === String(variant_id));
        let updatedQuantity = updatedLineItem ? updatedLineItem.quantity : 0;

        // Toggle the error message if the requested quantity is greater than the resulting quantity
        let cartItem = document.querySelector(`.cart-item[data-id="${variant_id}"]`);
        if (cartItem) {
          let itemError = cartItem.querySelector('.item-error');
          if (requestedQuantity > updatedQuantity) {
            itemError.textContent = "Sorry! That's all we have available.";
            itemError.style.display = "block";
          } else {
            itemError.textContent = "";
            itemError.style.display = "none";
          }
        }
      });
    })
    .catch(error => {
      console.log("Error:", error);
      throw error;
    });
}, 300);



// Swiper - Collection
var collectionSwiper = new Swiper(".collectionSwiper", {
  navigation: {
    nextEl: '.collectionSwiper-next',
    prevEl: '.collectionSwiper-prev'
  },
  // Default parameters
  loop: true,
  slidesPerView: 'auto',
  spaceBetween: 20,
  slidesPerGroupAuto: false,
  centeredSlides: true,
  noSwipingSelector: '.btn',
  watchSlidesVisibility: true,
  watchOverflow: true,
  allowTouchMove: false
});

// Desktop Product Swiper
$('.desktopProductSwiper .gallery-thumbs .product__media:first-child').addClass('selected');
$('.desktopProductSwiper .gallery-thumbs .product__media').on('click', function() {
  var id = $(this).data('id');
  $('.desktopProductSwiper .gallery-viewer .product__media').hide();
  $('.desktopProductSwiper .gallery-viewer .product__media[data-id="'+ id +'"]').show();
  $('.desktopProductSwiper .gallery-thumbs .product__media').removeClass('selected');
  $(this).addClass('selected');
});

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

});






// Debounce function
function debounce(fn, delay) {
  let timeoutId;
  return function(...args) {
    clearTimeout(timeoutId);
    return new Promise((resolve, reject) => {
      timeoutId = setTimeout(() => {
        try {
          const result = fn.apply(this, args);
          if (result instanceof Promise) {
            result.then(resolve).catch(reject);
          } else {
            resolve(result);
          }
        } catch (error) {
          reject(error);
        }
      }, delay);
    });
  };
}
// General function to clear all items from the cart
async function clearCart() {
  try {
    const data = { updates: {} };

    // Set each cart item's quantity to 0
    const cart = await fetch('/cart.js').then(response => response.json());
    cart.items.forEach(item => {
      data.updates[item.id] = 0;
    });

    // Make request to update the cart
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error('Failed to clear the cart');
    }

    console.log('Cart cleared successfully');

    // Remove all .cart-item elements inside cart-items
    document.querySelectorAll('cart-items .cart-item').forEach(item => item.remove());
    console.log(response);

    // Optionally call functions to re-render or fetch the cart data
    //renderCartItems(); - this was causing problems when there was only a $0 item in cart that was cleared, it was putting the UI back.
    fetchCartData();

  } catch (error) {
    console.error('Error clearing the cart:', error);
  }
}

function mobileMenuHandler(event) {
  // Only process click events or keydown events where Enter was pressed
  if (event.type === 'click' || (event.type === 'keydown' && event.key === 'Enter')) {
    
  }
}



document.addEventListener('DOMContentLoaded', function() {

  captureCartItems();

  const setCartItemLoading = (cartItem, isLoading) => {
    const itemPrice = cartItem.querySelector('.item-price');
    const itemPriceLoading = cartItem.querySelector('.item-price-loading');
    if (itemPrice) itemPrice.style.display = isLoading ? 'none' : 'block';
    if (itemPriceLoading) itemPriceLoading.style.display = isLoading ? 'block' : 'none';
  };

  const setCartItemError = (cartItem, message = '') => {
    const itemError = cartItem.querySelector('.item-error');
    if (!itemError) return;
    itemError.textContent = message;
    itemError.style.display = message ? 'block' : 'none';
  };

  const getInventoryLimit = (cartItem) => {
    const rawInventory = parseInt(cartItem.dataset.inv, 10);
    if (!Number.isFinite(rawInventory) || rawInventory <= 0) return null;
    return rawInventory;
  };

  const commitCartQuantity = (cartItem, quantity, previousQuantity) => {
    const variant_id = cartItem.dataset.id;
    const productTitle = cartItem.dataset.title || 'item';
    const quantityInput = cartItem.querySelector('.quantity__input');

    setCartItemLoading(cartItem, true);

    return updateCart(variant_id, quantity)
      .then(() => {
        if (quantityInput) {
          quantityInput.dataset.committedQty = String(quantity);
        }
        announceCartStatus('Quantity updated to ' + quantity + ' for ' + productTitle + '.');
      })
      .catch(() => {
        if (quantityInput) {
          quantityInput.value = String(previousQuantity);
          quantityInput.dataset.committedQty = String(previousQuantity);
        }
        setCartItemError(cartItem, 'Unable to update quantity. Please try again.');
      })
      .finally(() => {
        setCartItemLoading(cartItem, false);
      });
  };

  const validateManualQuantity = (cartItem, rawValue, fallbackQuantity) => {
    if (rawValue === '') {
      return { valid: false, quantity: fallbackQuantity, message: 'Enter a quantity of 1 or more.' };
    }

    const parsed = Number(rawValue);
    if (!Number.isInteger(parsed) || parsed < 1) {
      return { valid: false, quantity: fallbackQuantity, message: 'Enter a whole number of 1 or more.' };
    }

    const inventoryLimit = getInventoryLimit(cartItem);
    if (inventoryLimit !== null && parsed > inventoryLimit) {
      return { valid: true, quantity: inventoryLimit, message: 'Not enough inventory available.' };
    }

    return { valid: true, quantity: parsed, message: '' };
  };

  document.addEventListener('focusin', function(e) {
    const quantityInput = e.target.closest('.quantity__input');
    if (!quantityInput) return;

    if (!quantityInput.dataset.committedQty) {
      quantityInput.dataset.committedQty = quantityInput.value;
    }
    quantityInput.dataset.previousQty = quantityInput.value;
  });

  document.addEventListener('keydown', function(e) {
    const quantityInput = e.target.closest('.quantity__input');
    if (!quantityInput) return;

    if (e.key === 'Enter') {
      e.preventDefault();
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('change', function(e) {
    const quantityInput = e.target.closest('.quantity__input');
    if (!quantityInput) return;

    const cartItem = quantityInput.closest('.cart-item');
    if (!cartItem) return;

    const previousQuantity = parseInt(
      quantityInput.dataset.committedQty ||
      quantityInput.dataset.previousQty ||
      quantityInput.value,
      10
    ) || 1;

    const validationResult = validateManualQuantity(cartItem, quantityInput.value.trim(), previousQuantity);
    quantityInput.value = String(validationResult.quantity);

    if (!validationResult.valid) {
      setCartItemError(cartItem, validationResult.message);
      quantityInput.dataset.committedQty = String(previousQuantity);
      return;
    }

    if (validationResult.message) {
      setCartItemError(cartItem, validationResult.message);
    } else {
      setCartItemError(cartItem, '');
    }

    if (validationResult.quantity === previousQuantity) {
      return;
    }

    commitCartQuantity(cartItem, validationResult.quantity, previousQuantity);
  });

  document.addEventListener('click', function(e) {
    if (e.target.closest('.quantity_btn')) {
      e.preventDefault();
      const cartItem = e.target.closest('.cart-item');
      console.log(cartItem);
      if (!cartItem) return; // Safety check
      
      const quantityInput = cartItem.querySelector('.quantity__input');
      const variant_inv = getInventoryLimit(cartItem);
      let orr_quantity = parseInt(quantityInput.value, 10);
      console.log('orr_quantity: '+orr_quantity);
      let quantity = orr_quantity;
  
      if (e.target.closest('.btn-plus')) {
        if (variant_inv === null || variant_inv > orr_quantity) {
          quantity = orr_quantity + 1;
          setCartItemError(cartItem, '');
        } else {
          setCartItemError(cartItem, 'Not enough inventory available.');
          quantity = orr_quantity; // Prevent changing the quantity
        }
      } else if (e.target.closest('.btn-minus') && orr_quantity > 1) {
        quantity = orr_quantity - 1;
        setCartItemError(cartItem, '');
      }
      console.log('quantity: '+quantity);
  
      // Call updateCart, ensuring it is called once
      if (quantity !== orr_quantity) { // Prevent unnecessary calls if the quantity has not changed
        quantityInput.value = quantity;
        commitCartQuantity(cartItem, quantity, orr_quantity);
      }
    }
  });

  // Remove This Item
  document.addEventListener('click', async (e) => {
    const removeButton = e.target.closest('.remove-this-item');
    if (!removeButton) return;
    try {
      const cartItem = removeButton.closest('.cart-item');
      const itemId = cartItem.dataset.id;
      const data = { updates: { [itemId]: 0 } };
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
  
      if (!response.ok) {
        throw new Error('Failed to update the cart');
      }
      const result = await response.json();
      delete cartItemData[itemId];
      renderCartItems();
      fetchCartData();
      // WCAG 4.1.3: Announce cart status after removal (#3)
      const remainingItems = Object.keys(cartItemData).length;
      if (remainingItems === 0) {
        announceCartStatus('Your cart is now empty.');
      }
  
    } catch (error) {
      console.error("Error removing item from cart:", error);
    }
  });

  fetchCartData();
});



class MiniCartManager {
  constructor() {
    this.minicartSection = document.querySelector('#shopify-section-ocs-minicart');
    this.minicart = document.querySelector('#ocs-minicart');
    this.toggleButtons = document.querySelectorAll('.toggle-minicart');
    this.body = document.body;

    this.focusableElements = [];
    this.firstFocusableElement = null;
    this.lastFocusableElement = null;

    this.init();
  }

  init() {
    this.setInitialState();
    this.addToggleListeners();
  }

  setInitialState() {
    this.minicart.setAttribute('aria-hidden', 'true');
    this.minicartSection.classList.remove('open');
    this.body.classList.remove('noscroll');
  }

  setFocusTrap() {
    // Find all focusable elements inside the mini cart
    this.focusableElements = Array.from(
      this.minicart.querySelectorAll(
        'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select, [tabindex]:not([tabindex="-1"])'
      )
    );

    if (this.focusableElements.length > 0) {
      this.firstFocusableElement = this.focusableElements[0];
      this.lastFocusableElement = this.focusableElements[this.focusableElements.length - 1];
    }
  }

  handleFocusTrap(e) {
    if (e.key !== 'Tab') return;

    if (e.shiftKey) {
      // Shift + Tab: focus the last element if trying to shift-tab out of the first one
      if (document.activeElement === this.firstFocusableElement) {
        e.preventDefault();
        this.lastFocusableElement.focus();
      }
    } else {
      // Tab: focus the first element if trying to tab out of the last one
      if (document.activeElement === this.lastFocusableElement) {
        e.preventDefault();
        this.firstFocusableElement.focus();
      }
    }
  }

  openMiniCart() {
    this.minicartSection.classList.add('open');
    this.minicart.setAttribute('aria-hidden', 'false');
    this.body.classList.add('noscroll');
    
    this.setFocusTrap();  // Set up the focusable elements
    this.firstFocusableElement?.focus();  // Focus the first element inside

    // Add keydown listener for focus trapping
    document.addEventListener('keydown', this.handleFocusTrap.bind(this));
  }

  closeMiniCart() {
    this.minicartSection.classList.remove('open');
    this.minicart.setAttribute('aria-hidden', 'true');
    this.body.classList.remove('noscroll');

    // Return focus to the toggle button
    this.toggleButtons[0]?.focus();

    // Remove keydown listener for focus trapping
    document.removeEventListener('keydown', this.handleFocusTrap.bind(this));
  }

  toggleMiniCart() {
    const isOpen = this.minicart.getAttribute('aria-hidden') === 'false';
    isOpen ? this.closeMiniCart() : this.openMiniCart();
  }

  addToggleListeners() {
    // Toggle buttons (for both open and close actions)
    this.toggleButtons.forEach(button => {
      button.addEventListener('click', () => this.toggleMiniCart());

      button.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.toggleMiniCart();
        }
      });
    });

    // Close mini cart on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.minicart.getAttribute('aria-hidden') === 'false') {
        this.closeMiniCart();
      }
    });
  }
}

// Initialize the MiniCartManager
document.addEventListener('DOMContentLoaded', () => {
  window.miniCartManager = new MiniCartManager();
});



/* HEADER MANAGER */

class HeaderManager {
  constructor() {
    this.mobileToggleOn = document.querySelector('.mobile-toggle-on');
    this.mobileToggleOff = document.querySelector('.mobile-toggle-off');
    this.mobileMenu = document.querySelector('#mobile-menu');
    this.body = document.body;
    this.levelOneItems = document.querySelectorAll('.level-one');
    this.submenus = document.querySelectorAll('.submenu-slide');

    this.init();
  }

  init() {
    this.setInitialMenuState();
    this.disableAllTabbing(this.mobileMenu);
    this.addMobileMenuListeners();
    this.addLevelOneListeners();
    this.addBackLinkListeners();
  }

  setInitialMenuState() {
    this.mobileMenu.hidden = true;  // Ensure the menu is hidden initially
    this.mobileMenu.setAttribute('aria-hidden', 'true');
    this.mobileToggleOn.setAttribute('aria-expanded', 'false');
  }

  disableTabbing(container) {
    container.querySelectorAll('a, button, input, select, textarea').forEach(el => {
      el.setAttribute('tabindex', '-1');
    });
  }

  enableTabbing(container) {
    container.querySelectorAll('a, button, input, select, textarea').forEach(el => {
      el.removeAttribute('tabindex');
    });
  }

  disableAllTabbing(container) {
    this.disableTabbing(container);
    this.submenus.forEach(submenu => {
      submenu.setAttribute('aria-hidden', 'true');
      submenu.style.left = '-10000px';  // Visually hide the submenu
      this.disableTabbing(submenu);
    });
  }

  openMobileMenu() {
    this.mobileMenu.hidden = false;
    this.mobileMenu.setAttribute('aria-hidden', 'false');
    this.mobileMenu.setAttribute('open', '');
    this.mobileToggleOn.setAttribute('aria-expanded', 'true');
    this.body.classList.add('noscroll');

    this.enableTabbing(this.mobileMenu);  // Enable tabbing for the entire mobile menu
    this.mobileMenu.querySelector('button, a, input').focus();  // Set initial focus
  }

  closeMobileMenu() {
    this.mobileMenu.hidden = true;
    this.mobileMenu.setAttribute('aria-hidden', 'true');
    this.mobileMenu.removeAttribute('open');
    this.mobileToggleOn.setAttribute('aria-expanded', 'false');
    this.body.classList.remove('noscroll');

    this.disableAllTabbing(this.mobileMenu);  // Disable tabbing for all elements inside the menu
    this.mobileToggleOn.focus();  // Return focus to the menu open button
  }

  openSubmenu(submenu) {
    submenu.setAttribute('aria-hidden', 'false');
    submenu.style.left = '0';  // Move submenu into view
    this.enableTabbing(submenu);
  }

  focusFirstSubmenuItem(submenu) {
    if (!submenu) return;

    const firstFocusable = submenu.querySelector('button, a');
    if (firstFocusable) {
      setTimeout(() => {
        firstFocusable.focus();
      }, 0);
    }
  }

  closeSubmenu(submenu) {
    submenu.setAttribute('aria-hidden', 'true');
    submenu.style.left = '-10000px';  // Visually hide the submenu
    this.disableTabbing(submenu);
  }

  addMobileMenuListeners() {
    // Toggle on button click
    this.mobileToggleOn.addEventListener('click', () => this.openMobileMenu());
    this.mobileToggleOff.addEventListener('click', () => this.closeMobileMenu());

    // Close the menu on "Escape"
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.mobileMenu.getAttribute('aria-hidden') === 'false') {
        this.closeMobileMenu();
      }
    });
  }

  addLevelOneListeners() {
    this.levelOneItems.forEach(item => {
      item.addEventListener('click', (e) => {
        if (item.dataset.keyboardActivated === 'true') {
          item.dataset.keyboardActivated = 'false';
          e.preventDefault();
          return;
        }
        e.preventDefault();
        this.handleLevelOneInteraction(e, item);
      });

      item.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
          e.preventDefault();
          item.dataset.keyboardActivated = 'true';
          const submenu = item.nextElementSibling;
          this.handleLevelOneInteraction(e, item);
          if (submenu && submenu.classList.contains('submenu-slide')) {
            this.focusFirstSubmenuItem(submenu);
          }
        }
      });
    });
  }

  handleLevelOneInteraction(e, item) {
    const submenu = item.nextElementSibling;

    if (submenu && submenu.classList.contains('submenu-slide')) {
      const isSubmenuHidden = submenu.getAttribute('aria-hidden') === 'true';

      if (isSubmenuHidden) {
        this.openSubmenu(submenu);
        if (typeof item.blur === 'function') {
          item.blur();
        }
      } else {
        this.closeSubmenu(submenu);
      }
    }
  }

  addBackLinkListeners() {
    this.submenus.forEach(submenu => {
      const backLink = submenu.querySelector('.back-link');

      if (backLink) {
        backLink.addEventListener('click', () => {
          if (backLink.dataset.keyboardActivated === 'true') {
            backLink.dataset.keyboardActivated = 'false';
            return;
          }
          this.closeSubmenu(submenu);
          this.focusParentSubmenu(submenu);
        });

        backLink.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowLeft') {
            e.preventDefault();
            backLink.dataset.keyboardActivated = 'true';
            this.closeSubmenu(submenu);
            this.focusParentSubmenu(submenu);
          }
        });
      }
    });
  }

  focusParentSubmenu(submenu) {
    const parent = submenu.closest('.submenu-slide')?.previousElementSibling || submenu.closest('.submenu-slide')?.parentElement;

    if (parent) {
      const parentLevelOneLink = parent.querySelector('.level-one, .level-two');
      if (parentLevelOneLink) {
        parentLevelOneLink.focus();  // Return focus to the triggering parent
      }
    }
  }

  addNestedSubmenuListeners() {
    document.querySelectorAll('.level-two').forEach(levelTwoItem => {
      levelTwoItem.addEventListener('click', (e) => {
        if (levelTwoItem.dataset.keyboardActivated === 'true') {
          levelTwoItem.dataset.keyboardActivated = 'false';
          e.preventDefault();
          return;
        }
        const nestedSubmenu = levelTwoItem.nextElementSibling;

        if (nestedSubmenu && nestedSubmenu.classList.contains('submenu-slide')) {
          e.preventDefault();
          this.openSubmenu(nestedSubmenu);
        }
      });

      levelTwoItem.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
          e.preventDefault();
          levelTwoItem.dataset.keyboardActivated = 'true';
          const nestedSubmenu = levelTwoItem.nextElementSibling;

          if (nestedSubmenu && nestedSubmenu.classList.contains('submenu-slide')) {
            this.openSubmenu(nestedSubmenu);
            this.focusFirstSubmenuItem(nestedSubmenu);
          }
        }
      });
    });
  }

  addAnchorLinkListeners() {
    this.mobileMenu.querySelectorAll('a').forEach(link => {
      link.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          // Prevent submenu handling if it's a direct link without a submenu
          if (!link.nextElementSibling || !link.nextElementSibling.classList.contains('submenu-slide')) {
            e.preventDefault();  // Fix Enter behavior by allowing the link navigation
            window.location.href = link.href;
          }
        }
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const headerManager = new HeaderManager();
  headerManager.addNestedSubmenuListeners();
  headerManager.addAnchorLinkListeners();  // Added to fix the navigation issue on Enter
});


/* SEARCH DRAWER */
class SearchDrawerManager {
  constructor() {
    this.searchDrawer = document.querySelector('.search-drawer');
    this.openSearchButton = document.querySelector('.toggle-search.open-search');
    this.closeSearchButton = document.querySelector('.toggle-search.close-search');
    this.body = document.body;

    this.init();
  }

  init() {
    this.setInitialState();
    this.addToggleListeners();
  }

  setInitialState() {
    this.searchDrawer.setAttribute('aria-hidden', 'true');
    this.searchDrawer.hidden = true;
    this.closeSearchButton.style.display = 'none';  // Ensure close button is hidden by default
  }

  openSearchDrawer() {
    this.searchDrawer.hidden = false;
    this.searchDrawer.setAttribute('aria-hidden', 'false');
    this.searchDrawer.setAttribute('open', '');
    this.openSearchButton.style.display = 'none';
    this.closeSearchButton.style.display = 'block';
    this.body.classList.add('noscroll');
    this.searchDrawer.querySelector('.search-form-input').focus();  // Focus on search input
  }

  closeSearchDrawer() {
    this.searchDrawer.hidden = true;
    this.searchDrawer.setAttribute('aria-hidden', 'true');
    this.searchDrawer.removeAttribute('open');
    this.openSearchButton.style.display = 'block';
    this.closeSearchButton.style.display = 'none';
    this.body.classList.remove('noscroll');
    this.openSearchButton.focus();  // Return focus to the toggle button
  }

  toggleSearchDrawer() {
    const isDrawerOpen = this.searchDrawer.getAttribute('aria-hidden') === 'false';
    isDrawerOpen ? this.closeSearchDrawer() : this.openSearchDrawer();
  }

  addToggleListeners() {
    this.openSearchButton.addEventListener('click', () => this.toggleSearchDrawer());
    this.closeSearchButton.addEventListener('click', () => this.toggleSearchDrawer());

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.searchDrawer.getAttribute('aria-hidden') === 'false') {
        this.closeSearchDrawer();
      }
    });
  }
}

// Add aria-labels to generic "Read More" links to provide context (WCAG 2.5.3 Label in Name)
// This function looks for links with text "Read More" and adds descriptive aria-labels
const addReadMoreContextualLabels = () => {
  document.querySelectorAll('a').forEach(link => {
    const text = link.textContent.trim();
    
    // Only process links with exactly "Read More" text and no existing aria-label
    if (text === 'Read More' && !link.getAttribute('aria-label')) {
      // Try to determine context from nearby content
      const href = link.getAttribute('href');
      let context = '';
      
      // Extract context from href or nearby heading
      if (href) {
        // If href ends with a page slug like /pages/about, use that
        const lastSlug = href.split('/').pop();
        if (lastSlug && lastSlug !== '' && lastSlug !== '#') {
          context = lastSlug.replace(/[-_]/g, ' ').trim();
          context = context.charAt(0).toUpperCase() + context.slice(1);
        }
      }
      
      // If no context from href, try to find nearby heading or title
      if (!context) {
        const heading = link.closest('[data-section-type="ocs-about"]')?.querySelector('h2');
        if (heading) {
          const headingText = heading.textContent.trim();
          // Extract key words from heading
          context = headingText.split(' ').slice(0, 2).join(' ');
        }
      }
      
      // Set aria-label with context
      if (context) {
        const normalized = context.toLowerCase();
        if (normalized === 'about') {
          link.setAttribute('aria-label', 'Read More about our story');
        } else {
          link.setAttribute('aria-label', `Read More about ${context}`);
        }
      } else {
        link.setAttribute('aria-label', 'Read More');
      }
    }
  });
};

// Normalize footer email signup field naming to avoid duplicate announcements (Issue #10)
const normalizeFooterSignupInputA11y = () => {
  const subscribe = document.querySelector('.site-footer .subscribe');
  if (!subscribe) return;

  const emailInputs = Array.from(subscribe.querySelectorAll('input[type="email"]'));
  if (!emailInputs.length) return;

  emailInputs.forEach((input, index) => {
    const inputId = input.id || `footer-email-signup-input-${index + 1}`;
    input.id = inputId;

    const labelId = `footer-email-signup-label-${index + 1}`;
    let label = subscribe.querySelector(`#${labelId}`);
    if (!label) {
      label = document.createElement('label');
      label.id = labelId;
      label.className = 'visually-hidden';
      label.textContent = 'Email address';
      label.setAttribute('data-a11y-signup-label', 'true');
    }

    label.setAttribute('for', inputId);
    if (input.parentElement && label.parentElement !== input.parentElement) {
      input.parentElement.insertBefore(label, input);
    }

    input.setAttribute('aria-labelledby', labelId);

    // Remove duplicate name sources when vendor markup mirrors placeholder text.
    const placeholder = (input.getAttribute('placeholder') || '').trim().toLowerCase();
    const ariaLabel = (input.getAttribute('aria-label') || '').trim().toLowerCase();
    const title = (input.getAttribute('title') || '').trim().toLowerCase();

    if (ariaLabel && (ariaLabel === placeholder || ariaLabel === 'enter your email address')) {
      input.removeAttribute('aria-label');
    }
    if (title && (title === placeholder || title === 'enter your email address')) {
      input.removeAttribute('title');
    }
  });
};

// Add missing alt text to images (WCAG 1.1.1 Non-text Content)
// Finds images without alt attributes and adds descriptive alt text based on context
const addMissingImageAltText = () => {
  document.querySelectorAll('img').forEach(img => {
    // Skip if image already has alt text
    if (img.hasAttribute('alt')) {
      return;
    }
    
    // Skip if image is decorative or aria-hidden
    if (img.hasAttribute('aria-hidden') || img.getAttribute('role') === 'presentation') {
      // For true decorative images, add empty alt
      if (!img.hasAttribute('alt')) {
        img.setAttribute('alt', '');
      }
      return;
    }
    
    let altText = '';
    
    // Try to determine context for alt text
    
    // 1. Check if image has title attribute or data attributes
    if (img.hasAttribute('title')) {
      altText = img.getAttribute('title');
    }
    
    // 2. Check if parent has context (product card, section, etc.)
    if (!altText) {
      const productCard = img.closest('[data-product-id], .card, .product-item, .product-card');
      if (productCard) {
        const productTitle = productCard.querySelector('h2, .product-title, .card-title');
        if (productTitle) {
          altText = productTitle.textContent.trim();
        }
      }
    }
    
    // 3. Check for nearby heading or descriptive elements
    if (!altText) {
      const heading = img.closest('section, article, .section')?.querySelector('h1, h2, h3');
      if (heading) {
        altText = heading.textContent.trim();
      }
    }
    
    // 4. Check if it's a preview/thumbnail image
    if (!altText && img.classList.contains('preview')) {
      altText = 'Product preview image';
    }
    
    // 5. Check if it's a video thumbnail/cover
    if (!altText && (img.parentElement?.classList.contains('item-video') || 
                      img.parentElement?.classList.contains('card-video') ||
                      img.parentElement?.classList.contains('video-thumbnail'))) {
      altText = 'Video thumbnail';
    }
    
    // 6. Check for logo or brand images
    if (!altText && (img.classList.contains('logo') || img.src.includes('logo'))) {
      altText = 'Laredo Boots logo';
    }
    
    // 7. Check for shop-pay or payment logos
    if (!altText && img.src.includes('shoppay')) {
      altText = 'Shop Pay logo';
    }
    
    // 8. Check filename for clues
    if (!altText) {
      const srcParts = img.src.split('/');
      const filename = srcParts[srcParts.length - 1].split('?')[0];
      if (filename && filename.length > 0 && filename !== 'image') {
        altText = filename.replace(/[-_]/g, ' ').replace(/\.(jpg|jpeg|png|svg|webp|gif)$/i, '').trim();
      }
    }
    
    // Set alt text
    if (altText) {
      img.setAttribute('alt', altText);
    } else {
      // If no context found, use generic but descriptive alt
      img.setAttribute('alt', 'Image');
    }
  });
};

// Apply title attribute to Shopify preview bar iframe for accessibility (WCAG 4.1.2)
function applyPreviewBarIframeTitle(root = document) {
  const iframe = root.querySelector('#PBarNextFrame');
  if (!iframe) return;
  if (!iframe.getAttribute('title')) {
    iframe.setAttribute('title', 'Shopify preview bar');
  }
}

// Hide mobile facets from accessibility tree when displayed via CSS display:none on larger breakpoints
function manageMobileFacetsAriaHidden() {
  const mobileWrapper = document.querySelector('.mobile-facets__wrapper');
  if (!mobileWrapper) return;
  
  const isHidden = window.getComputedStyle(mobileWrapper).display === 'none';
  
  if (isHidden) {
    // When hidden on desktop, remove from accessibility tree and focus order
    mobileWrapper.setAttribute('aria-hidden', 'true');
    mobileWrapper.setAttribute('tabindex', '-1');
  } else {
    // When visible on mobile, include in accessibility tree and focus order
    mobileWrapper.setAttribute('aria-hidden', 'false');
    mobileWrapper.removeAttribute('tabindex');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new SearchDrawerManager();
  addReadMoreContextualLabels();
  normalizeFooterSignupInputA11y();
  addMissingImageAltText();
  enhanceVagueImageAltText();
  applyPreviewBarIframeTitle();
  manageMobileFacetsAriaHidden();
  
  // Re-run when content is dynamically loaded
  const observer = new MutationObserver(() => {
    addReadMoreContextualLabels();
    normalizeFooterSignupInputA11y();
    addMissingImageAltText();
    enhanceVagueImageAltText();
    manageMobileFacetsAriaHidden();
    
    // Check for dynamically added preview bar iframe
    if (document.querySelector('#PBarNextFrame')) {
      applyPreviewBarIframeTitle();
    }
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
  
  // Also monitor window resize to update aria-hidden on breakpoint changes
  window.addEventListener('resize', manageMobileFacetsAriaHidden);
  
  // Mark Yotpo shop badge SVGs as decorative (WCAG 1.1.1 - SVG accessible name)
  // Yotpo injects shop badge SVGs that don't have accessible names; mark them as presentation
  function markYotpoShopBadgesAsDecorative() {
    // Select all Yotpo shop badge SVGs by class
    const yotpoBadges = document.querySelectorAll('svg.yotpo-shop-badge, [class*="yotpo"][class*="badge"] svg');
    yotpoBadges.forEach(svg => {
      // Force set attributes to ensure they're applied
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('role', 'presentation');
      // Also mark immediate parent containers if they exist
      if (svg.parentElement && svg.parentElement.classList && svg.parentElement.classList.contains('yotpo-icon-button__icon')) {
        svg.parentElement.setAttribute('aria-hidden', 'true');
      }
    });
    // Also check for any unencoded SVGs that might be pure decorative
    const allSvgs = document.querySelectorAll('svg');
    allSvgs.forEach(svg => {
      if (svg.classList.contains('yotpo-shop-badge') || (svg.parentElement && svg.parentElement.classList && svg.parentElement.classList.contains('yotpo-shop-badge'))) {
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('role', 'presentation');
      }
    });
  }

  // Fix Yotpo mobile filter button contrast (WCAG 1.4.11 - Non-text Contrast)
  // Yotpo mobile filters button has light gray border that lacks sufficient contrast
  function fixYotpoMobileFilterButtonContrast() {
    const yotpoFilterBtns = document.querySelectorAll('.yotpo-mobile-filters-btn, .yotpo-mobile-filters-popup-btn');
    yotpoFilterBtns.forEach(btn => {
      // Replace light gray border with dark border for contrast
      btn.style.setProperty('border-color', '#2C2C2C', 'important');
      btn.style.setProperty('border', '2px solid #2C2C2C', 'important');
    });
  }
  
  // Fix Klaviyo form button contrast (WCAG 1.4.11 - Non-text Contrast)
  // Apply box-shadow for visible boundaries with contrast on both light and dark backgrounds
  // function fixKlaviyoButtonContrast() {
  //   // Fix buttons - use outline for visual boundary with sufficient contrast
  //   const klaviyoButtons = document.querySelectorAll('button[class*="go"][class*="kl-private"], .ocs-subscribe button, .klaviyo-form button, button.needsclick');
  //   klaviyoButtons.forEach(button => {
  //     button.style.setProperty('border', 'none', 'important');
      
  //     // Determine if button has a light or dark background
  //     const bgColor = window.getComputedStyle(button).backgroundColor;
  //     const rgb = bgColor.match(/\d+/g);
      
  //     if (rgb && rgb.length >= 3) {
  //       // Calculate luminance to determine if background is light or dark
  //       const r = parseInt(rgb[0]);
  //       const g = parseInt(rgb[1]);
  //       const b = parseInt(rgb[2]);
  //       const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        
  //       // Use white outline for dark backgrounds, black for light backgrounds
  //       const outlineColor = luminance < 0.5 ? '#FFFFFF' : '#000000';
  //       button.style.setProperty('outline', '3px solid ' + outlineColor, 'important');
  //     } else {
  //       // Default to black outline if unable to determine background
  //       button.style.setProperty('outline', '3px solid #000000', 'important');
  //     }
      
  //     button.style.setProperty('outline-offset', '2px', 'important');
  //   });
    
    // Fix input fields (email, text, etc.) - ensure text is visible and outline has contrast
    // Target all Klaviyo inputs by class selectors since they may not be direct children of .klaviyo-form
  //   const klaviyoInputs = document.querySelectorAll('input[class*="go"][class*="kl-private"], input.kl-private-reset-css-Xuajs1, .ocs-subscribe input, .klaviyo-form input');
  //   klaviyoInputs.forEach(input => {
  //     input.style.setProperty('background-color', 'rgb(255, 255, 255)', 'important');
  //     input.style.setProperty('background', 'rgb(255, 255, 255)', 'important');
  //     input.style.setProperty('border', 'none', 'important');
      
  //     // Set dark text color for contrast on white background (WCAG 1.4.3)
  //     input.style.setProperty('color', '#222222', 'important');
      
  //     // Use gold outline for modal/Klaviyo inputs, dark outline for newsletter
  //     const isNewsletterInput = input.closest('.ocs-subscribe');
  //     const outlineColor = isNewsletterInput ? '#525252' : '#C9A961';
      
  //     // Add z-index to ensure outline is visible
  //     input.style.setProperty('position', 'relative', 'important');
  //     input.style.setProperty('z-index', '10', 'important');
      
  //     // Use outline to create a true visual boundary with text visibility
  //     input.style.setProperty('outline', '3px solid ' + outlineColor, 'important');
  //     input.style.setProperty('outline-offset', '2px', 'important');
  //   });
  // }
  
  // Fix Klaviyo image accessible names (WCAG 1.1.1 - Non-text Content)
  // function fixKlaviyoImageAltText() {
  //   // Target images inside Klaviyo forms and images with Klaviyo classes anywhere on the page
  //   const klaviyoImages = document.querySelectorAll('.klaviyo-form img, .kl-form img, img[class*="kl-private"]');
  //   klaviyoImages.forEach(img => {
  //     // Check if it's a logo/branding image by looking at alt text or filename
  //     const alt = img.getAttribute('alt') || '';
  //     const src = img.src || '';
  //     const ariaLabel = img.getAttribute('aria-label') || '';
  //     const isLogo = alt.includes('Logo') || alt.includes('logo') || src.includes('logo') || ariaLabel.includes('Logo') || ariaLabel.includes('logo');
      
  //     if (isLogo) {
  //       // Logo images in forms are purely decorative branding - remove from accessibility tree
  //       img.setAttribute('alt', '');
  //       img.setAttribute('aria-hidden', 'true');
  //       img.setAttribute('role', 'presentation');
  //       // Remove any aria-label that might announce the logo
  //       img.removeAttribute('aria-label');
  //     } else {
  //       // For other images, ensure alt text is present and meaningful
  //       if (img.alt && img.alt.trim()) {
  //         // Add aria-label to match alt text for extra clarity
  //         img.setAttribute('aria-label', img.alt);
          
  //         // Ensure role is properly set
  //         if (!img.getAttribute('role')) {
  //           img.setAttribute('role', 'img');
  //         }
  //       } else if (img.alt === '') {
  //         // If alt is empty and this is decorative, ensure it's properly hidden
  //         img.setAttribute('aria-hidden', 'true');
  //       }
  //     }
  //   });
  // }
  
  // Enhance vague image alt text for clarity (WCAG 1.1.1 - Non-text Content)
  function enhanceVagueImageAltText() {
    const images = document.querySelectorAll('img[alt]');
    images.forEach(img => {
      const alt = img.getAttribute('alt') || '';
      const src = img.src || '';
      
      // Map of vague alt text to more descriptive versions based on filename
      const vagueAltMap = {
        'Narrow': 'Narrow toe width boot style',
        'Round': 'Round toe width boot style',
        'Snip': 'Snip toe style',
        'Square': 'Square toe width boot style',
        'Snip Toe': 'Snip toe style boot',
        'Round Toe': 'Round toe width boot style',
        'Square Toe': 'Square toe width boot style'
      };
      
      // Check if alt text is in the vague map
      if (vagueAltMap[alt]) {
        img.setAttribute('alt', vagueAltMap[alt]);
      }
      // For toe icon images specifically, enhance based on filename
      else if (src.includes('ico-toe-')) {
        const toeType = src.match(/ico-toe-(\w+)/)?.[1];
        if (toeType) {
          const toeNames = {
            'narrow': 'Narrow toe width',
            'round': 'Round toe width',
            'snip': 'Snip toe style',
            'square': 'Square toe width'
          };
          const descriptive = toeNames[toeType] || toeType;
          if (alt && alt.length <= 10) {
            img.setAttribute('alt', `${descriptive} boot icon`);
          }
        }
      }
      // For product images with just product name, add context if very short
      else if (alt && alt.length > 0 && alt.length <= 5 && !src.includes('logo')) {
        // Single-word alts that aren't product names might need context
        if (!alt.match(/\b(boot|shoe|product)\b/i)) {
          // Only enhance if it looks like a single word or number
          if (!alt.includes(' ')) {
            img.setAttribute('alt', `${alt} boot product`);
          }
        }
      }
    });
  }

  // Mark elements hidden with display: none as aria-hidden for accessibility (WCAG 4.1.2)
  function markDisplayNoneAsAriaHidden() {
    // Find all elements that are hidden with display: none via computed styles
    const allElements = document.querySelectorAll('*');
    allElements.forEach(element => {
      const computed = window.getComputedStyle(element);
      if (computed.display === 'none' && !element.hasAttribute('aria-hidden')) {
        element.setAttribute('aria-hidden', 'true');
      }
    });
  }
  
  // Mark Yotpo mobile panels as aria-hidden when hidden on mobile viewports (WCAG 4.1.2)
  function markYotpoPanelsAsAriaHidden() {
    const panels = document.querySelectorAll('.yotpo-filters-top-panel, .yotpo-smart-topics-panel');
    panels.forEach(panel => {
      const computed = window.getComputedStyle(panel);
      // Mark as aria-hidden if display is none (hidden on mobile)
      if (computed.display === 'none' && !panel.hasAttribute('aria-hidden')) {
        panel.setAttribute('aria-hidden', 'true');
      } else if (computed.display !== 'none' && panel.getAttribute('aria-hidden') === 'true') {
        // Remove aria-hidden if panel is visible (on desktop)
        panel.removeAttribute('aria-hidden');
      }
    });
  }
  
  // Run on initial load
  //fixKlaviyoButtonContrast();
  //fixKlaviyoImageAltText();
  markDisplayNoneAsAriaHidden();
  markYotpoPanelsAsAriaHidden();
  enhanceVagueImageAltText();
  markYotpoShopBadgesAsDecorative();
  fixYotpoMobileFilterButtonContrast();
  
  // Re-apply Klaviyo fixes on resize to catch mobile view changes (WCAG 1.4.11)
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      //fixKlaviyoButtonContrast();
      fixYotpoMobileFilterButtonContrast();
      markYotpoPanelsAsAriaHidden();
    }, 250);
  });
  
  // Re-run when Klaviyo dynamically adds/updates forms or Yotpo injects content
  // const klaviyoObserver = new MutationObserver((mutations) => {
  //   let shouldCheckYotpo = false;
  //   mutations.forEach((mutation) => {
  //     if (mutation.type === 'childList' || mutation.type === 'attributes') {
  //       // Check if any Klaviyo elements were added
  //       if (mutation.addedNodes.length > 0 || (mutation.target.className && mutation.target.className.includes('kl-'))) {
  //         fixKlaviyoButtonContrast();
  //         fixKlaviyoImageAltText();
  //       }
  //       // Check for Yotpo mobile filter button changes
  //       if (mutation.addedNodes.length > 0 || (mutation.target.className && mutation.target.className.includes('yotpo'))) {
  //         fixYotpoMobileFilterButtonContrast();
  //         markYotpoPanelsAsAriaHidden();
  //       }
  //       // Mark for Yotpo check if any nodes were added
  //       if (mutation.addedNodes.length > 0) {
  //         shouldCheckYotpo = true;
  //       }
  //     }
  //   });
  //   // Always check for Yotpo badges on any mutation to ensure they're caught
  //   if (shouldCheckYotpo) {
  //     markYotpoShopBadgesAsDecorative();
  //   }
  // });
  
  // Suppress modal dismissal for accessibility testing (prevent Escape key from closing Klaviyo modals)
  // document.addEventListener('keydown', (event) => {
  //   if (event.key === 'Escape') {
  //     const klaviyoModal = document.querySelector('.kl-overlay, [class*="kl-"][class*="overlay"], .klaviyo-form');
  //     if (klaviyoModal) {
  //       event.preventDefault();
  //       event.stopPropagation();
  //     }
  //   }
  // }, true);
  
  // klaviyoObserver.observe(document.body, { 
  //   childList: true, 
  //   subtree: true,
  //   attributes: true,
  //   attributeFilter: ['style']
  // });

  // WCAG 2.4.7: Prevent AudioEye widget buttons from receiving keyboard focus when
  // visually hidden. AudioEye injects "Open smart search chat" and "Hide smart search"
  // buttons into the footer that are visually hidden but remain in the tab order. (#4)
  function suppressHiddenAudioEyeButtons() {
    // Target AudioEye-injected buttons by aria-label pattern
    const aeButtons = document.querySelectorAll(
      'button[aria-label*="smart search"], button[aria-label*="AudioEye"], [class*="audioeye"] button, [id*="audioeye"] button'
    );
    aeButtons.forEach(function(btn) {
      var style = window.getComputedStyle(btn);
      var parent = btn.parentElement;
      var parentStyle = parent ? window.getComputedStyle(parent) : null;
      var isHidden = style.display === 'none' || style.visibility === 'hidden' ||
        style.opacity === '0' || parseFloat(style.opacity) < 0.01 ||
        (parentStyle && (parentStyle.display === 'none' || parentStyle.visibility === 'hidden'));
      if (isHidden) {
        btn.setAttribute('tabindex', '-1');
        btn.setAttribute('aria-hidden', 'true');
      } else {
        // Restore if it becomes visible
        if (btn.getAttribute('tabindex') === '-1' && btn.dataset.aeManaged) {
          btn.removeAttribute('tabindex');
          btn.removeAttribute('aria-hidden');
        }
      }
      btn.dataset.aeManaged = 'true';
    });
  }

  suppressHiddenAudioEyeButtons();

  // Re-check whenever AudioEye injects/mutates elements
  const aeObserver = new MutationObserver(function() {
    suppressHiddenAudioEyeButtons();
  });
  aeObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
});